import CustomAxios from "..";

export const getUsersCount = async (params = {  }) => {
  try {
    const response = await CustomAxios.get("/admin/users-count",{ params });
    return response.data;
  } catch (error) {
    console.error("Error fetching users count:", error);
    throw error;
  }
};

export const getUsersCountfilter = async (params = {  }) => {
  try {
    const response = await CustomAxios.get("/admin/get-users/filter",{ params });
    return response.data;
  } catch (error) {
    console.error("Error fetching users count:", error);
    throw error;
  }
};


export const getdashboardData = async () => {
  try {
    const response = await CustomAxios.get("/admin/dashboard");
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard count:", error);
    throw error;
  }
};

export const getPlanCount = async () => {
  try {
    const response = await CustomAxios.get("/admin/plan-count");
    return response.data;
  } catch (error) {
    console.error("Error fetching plan count:", error);
    throw error;
  }
};

export const getWorkoutCount = async () => {
  try {
    const response = await CustomAxios.get("/admin/workout-count");
    return response.data;
  } catch (error) {
    console.error("Error fetching workout count:", error);
    throw error;
  }
};
